/**
 * 필수 유무
 * @param v
 * @returns
 */
export const isRequired = (v) => !!v;
/** 필수 유무 (숫자0도 유효값) */
export const isRequiredZeroAvailable = (v) => v !== null && v !== undefined && v !== '';
/** 10진법 숫자 유무 */
export const isDecimalNumber = (v) => {
    const value = Number.parseInt(v, 10);
    return !Number.isNaN(value);
};
/**
 * 특정 값 보다 큰 수
 * @param v
 * @param target
 * @returns
 */
export const greaterThanTargetNumber = (v, target = 0) => (parseInt(v, 10) > target);
/** max 이하인 수 */
export const lessThanMaxAmount = (v, max) => {
    const isInteger = Number.isInteger(v);
    // 정수인 경우
    if (isInteger) {
        return parseInt(String(v), 10) <= max;
    }
    // 소수점인 경우
    return parseFloat(String(v)) <= max;
};
/** limitLength과 같은 길이 */
export const isSameAsLimitLength = (length, limitLength) => (length === limitLength);
/** limitLength 이상인 길이 */
export const greaterThanMinLength = (length, limitLength) => (length >= limitLength);
/** limitLength 이하인 길이 */
export const lessThanMaxLength = (length, limitLength) => (length <= limitLength);
/** 정규식 패턴 일치여부 */
export const isValidPattern = (pattern, value) => {
    // ex: 차량번호 regex의 경우 array type, 이메일의 경우는 string type
    const regexList = Array.isArray(pattern) ? pattern : [
        pattern,
    ];
    return regexList
        .some((regex) => regex.test(value));
};
/**
 * 기존 date 기간과 일치 여부
 * @param {Object} Date object, {currentFromDate:timestamp, currentToDate:timestamp}
 * @param {Object} Date object, {newFromDate:timestamp, newToDate:timestamp}
 * @returns {boolean}
 */
export const isAlreadyExistDateRange = ({ currentFromDate, currentToDate, }, { newFromDate, newToDate, }) => {
    if ((currentFromDate === newFromDate)
        && (currentToDate === newToDate)) {
        return true;
    }
    return false;
};
/**
 * 기존 date 기간에 포함되는지 여부
 * @param {Object} Date object, {currentFromDate:timestamp, currentToDate:timestamp}
 * @param {Object} Date object, {newFromDate:timestamp, newToDate:timestamp}
 * @returns {boolean}
 */
export const isAlreadyIncludeDateRange = ({ currentFromDate, currentToDate, }, { newFromDate, newToDate, }) => {
    if ((currentFromDate <= newFromDate)
        && (currentToDate >= newToDate)) {
        return true;
    }
    return false;
};
/** 시작범위가 종료범위보다 큰 값인지 여부 */
export const isEndValueGreaterThanStartValue = (startValue, endValue) => startValue < endValue;
